export default __webpack_public_path__ + "./images/lk.2a7b56fd.png";